export const ASK_AI_COPY = {
  heading: 'Ask an AI assistant to evaluate BizRnR',
  body: 'Opens ChatGPT, Gemini, Claude, Grok, or Perplexity with a neutral, source-checking question ready to send.',
  disclosure: 'The assistant controls its answer. Opening a prompt does not imply an endorsement or recommendation.',
} as const;
